import { useContext, useEffect, useState } from "react";
import axios from 'fetch/axios';
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import imgUpsEsp from "@assets/images/UpsWeb_esp.svg";
import imgUpsIng from "@assets/images/UpsWeb_ing.svg";

const Component = () => {
  const { lang } = useContext(LanguageCurrencyContext);
  const [ setTerminos] = useState(null);

  useEffect(() => {

    const fetchPoliticas = async () => {
      try {
        const response = await axios.get('/legal-texts/detail/1' + `?lang=` + lang);
        setTerminos(response.data?.data);
      } catch (error) {
        console.error('Error fetching Instagram posts', error);
      }
    };
    fetchPoliticas();

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    
  }, [lang])

  return (
    <>
      <section className="pt-tophead">
        
        <article className="ArticleStaticContent">
            <div className="content-grid-ups">
                <div><a href="https://www.instagram.com/arteonu/" target="_blank"><img src={imgUpsIng} alt="" /></a></div>
                <div><a href="https://www.instagram.com/arteonu/" target="_blank"><img src={imgUpsEsp} alt="" /></a></div>
            </div>
        </article>

      </section>
    </>
  );
};

export default Component;
